import axios from "axios";

// Lấy URL từ file .env hoặc mặc định là localhost:8000
const apiURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * Kiểm tra trạng thái đăng nhập
 * Trả về object chứa token và user nếu đã login, ngược lại trả về false
 */
export const isAuthenticate = () =>
  localStorage.getItem("jwt") ? JSON.parse(localStorage.getItem("jwt")) : false;

/**
 * Kiểm tra quyền Admin (Role = 1)
 */
export const isAdmin = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).user.role === 1
    : false;

/**
 * Kiểm tra quyền Chủ shop (Role = 2)
 */
export const isShopOwner = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).user.role === 2
    : false;

/**
 * API Đăng nhập
 * @param {Object} credentials - Gồm email và password
 */
export const loginReq = async ({ email, password }) => {
  const data = { email, password };
  try {
    // Đã thêm tiền tố /api để khớp với router.use("/api", authRouter) ở backend
    let res = await axios.post(`${apiURL}/api/signin`, data);
    return res.data;
  } catch (error) {
    console.error("Login API Error:", error);
    // Trả về object lỗi từ backend nếu có (ví dụ: {error: "Sai mật khẩu"})
    return error.response ? error.response.data : { error: "Không thể kết nối đến server" };
  }
};

/**
 * API Đăng ký
 * @param {Object} userData - Gồm name, email, password, cPassword
 */
export const signupReq = async ({ name, email, password, cPassword }) => {
  const data = { name, email, password, cPassword };
  try {
    // Đã thêm tiền tố /api để tránh lỗi 404
    let res = await axios.post(`${apiURL}/api/signup`, data);
    return res.data;
  } catch (error) {
    console.error("Signup API Error:", error);
    return error.response ? error.response.data : { error: "Không thể kết nối đến server" };
  }
};